export default __webpack_public_path__ + "static/media/3-cassettes-open-1-left.d6d9aa73.svg";